import axios from 'axios'
import _get from 'lodash/get'

export const STUDENT_LOAN_GET = 'STUDENT_LOAN_GET'
export const STUDENT_LOAN_UPDATE = 'STUDENT_LOAN_UPDATE'
export const STUDENT_LOAN_SAVE = 'STUDENT_LOAN_SAVE'
export const STUDENT_LOAN_SAVING = 'STUDENT_LOAN_SAVING'
export const STUDENT_LOAN_SAVE_SUCCESS = 'STUDENT_LOAN_SAVE_SUCCESS'
export const STUDENT_LOAN_SAVE_ERROR = 'STUDENT_LOAN_SAVE_ERROR'

export const getStudentLoan = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/studentloan/${selfAssessmentId}`)
        .then((response) => {
            const studentLoan = { ...response.data, shouldFetch: false, fetchSuccessful: true }

            dispatch(updateStudentLoan(studentLoan))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updateStudentLoan({ shouldFetch: false, fetchSuccessful: true }))
            }
        })
}

export const updateStudentLoan = (studentLoan) => ({
    type: STUDENT_LOAN_UPDATE,
    studentLoan,
})

export const saveStudentLoan = () => (dispatch, getState) => {
    const { assessment, studentLoan } = getState()

    dispatch(studentLoanSaving, studentLoan)

    axios
        .put(`/studentloan/${assessment.id}`, { ...studentLoan, selfAssessmentId: assessment.id })
        .then((response) => {
            const data = { ...response.data, isAllowanceUpdate: studentLoan.isAllowanceUpdate }

            dispatch(studentLoanSaveSuccess(data))
        })
        .catch((error) => {
            dispatch(studentLoanSaveError(studentLoan, _get(error, ['response', 'data'])))
        })
}

export const updateAndSaveStudentLoan = (studentLoan) => (dispatch) => {
    dispatch(updateStudentLoan(studentLoan))
    dispatch(saveStudentLoan())
}

export const studentLoanSaving = (studentLoan) => ({
    type: STUDENT_LOAN_SAVING,
    studentLoan,
})

export const studentLoanSaveSuccess = (studentLoan) => ({
    type: STUDENT_LOAN_SAVE_SUCCESS,
    studentLoan,
})

export const studentLoanSaveError = (studentLoan, errorResponse) => ({
    type: STUDENT_LOAN_SAVE_ERROR,
    studentLoan,
    errorResponse,
})
